var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.loading
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("v-progress-linear", {
                attrs: {
                  indeterminate: "",
                  color: "green"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.migrationsFormatted, function(migration) {
        return _c(
          "v-col",
          {
            key: "mi-".concat(migration.id),
            attrs: {
              cols: "12"
            }
          },
          [
            _c("migrations-list-item", {
              attrs: {
                migration: migration
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }